export enum PersonalVerificationMethod {
    ekyc_ho = 'eKYC（ホ）',
    personal_identity_verification = '公的個人認証',
}

export enum PersonalVerificationDocument {
    passport = 'passport',
    driver_license = 'drivers_license',
    individual_number_card = 'individual_number_card',
    basic_resident_registration_card = 'basic_resident_registration_card',
    residence_card = 'residence_card',
    driving_history_certificate = 'driving_history_certificate',
    special_permanent_resident_certificate = 'special_permanent_resident_certificate'
}

export enum Status {
    approved = 'approved',
    denied = 'denied',
    not_verified = 'not_verified'
}

export interface PersonalVerificationData {
    id: string;
    verificationId: string;
    publicId: string;
    personalVerificationDocument?: string;
    personalVerificationMethod?: string;
    receivedDate: string;
    updateDate: string;
    verificationDate?: string;
    state: string;
    result?: string;
    reasonCode?: string;
    verificationMemo?: string;
    lastDownloadedDate?: string;
    deleteFromTrustdockDate?: string;
    isDeletedFromTrustdock?: boolean;
    isDeleted?: boolean;
}
